import React from "react";
import {CenteredDesign} from "../../../components/DesignSystem/CenteredDesign/CenteredDesign";
import {Card} from "antd";


export const PrivacyPolicyPage = () => {

    return <CenteredDesign sm={16} lg={14}>

        <h1>Privacy Policy</h1>

        <h2>1. INITIAL PROVISIONS</h2>

        <p>1.1 This is the Privacy Policy of ApiMoon s.r.o., a company incorporated in the Czech Republic, ID No. 075 29 449, registered office:
            Na Korábě 2483/3, Libeň, 180 00 Prague 8, Czech Republic, registered with the Municipal Court in Prague, file No. C 302197 (also
            “ApiMoon” or “we”, “us” or “our”). We refer to all our products, services, websites and apps collectively as the“ApiMoon Services” in
            this Privacy Policy.
        </p>

        <p>1.2 We respect the need for privacy and protection of personal information, including but not limited to any personal data. For the
            purposes of this Privacy Policy, personal data shall mean any information relating to an identified or identifiable natural person,
            where an identifiable natural person is one who can be identified, directly or indirectly, in particular by reference to an
            identifier such as a name, an identification number, location data, an online identifier or to one or more factors specific to the
            physical, physiological, genetic, mental, economic, cultural or social identity of that natural person.
        </p>

        <p>1.3 We always process Personal Data in accordance with this Privacy Policy and applicable legislation, such as Regulation (EU)
            2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the
            processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (the “GDPR”).</p>

        <p>
            1.4 Please read this Privacy Policy carefully to understand how we collect, process and protect Personal Data if you use the ApiMoon
            Services, and what rights you have in this connection. By using the ApiMoon Services and/or providing any Personal Data to us, you
            consent to be bound by this Privacy Policy and warrant that all Personal Data provided by you is accurate and that you are authorized
            to provide such Personal Data to us.
        </p>

        <p>
            1.5 For the purpose of this Privacy Policy and unless the context requires otherwise, we shall be considered as the data controller
            of Personal Data.
        </p>

        <h1>2. CATEGORIES OF PERSONAL DATA</h1>

        <p>2.1 We collect, process and protect, in particular, the following categories of Personal Data:</p>

        <ul>
            <li>
                a) Personal Data
                <ul>
                    <li>Identification data (e.g., first name, last name, sex, account user name);</li>
                    <li>Contact information (e.g., e-mail address, telephone number);</li>
                    <li>Delivery information (e.g., delivery address);</li>
                    <li>Order information (e.g., products purchased);</li>
                    <li>Payment information;</li>
                    <li>IP address; and</li>
                    <li>Other Personal Data you share with us.

                        While using the ApiMoon Services, we may ask you to provide us with the above-mentioned Personal Data which can be used
                        to contact or identify you. We may use Personal Data also to contact you using newsletters, marketing or promotional
                        materials and provide you with other information that may be of interest to you. You may opt out of receiving any, or
                        all, of these communications from us by following the unsubscribe link or reaching out to us at support@apimoon.com.
                    </li>
                </ul>
            </li>
            <li>b) Tracking & Cookies Data</li>
        </ul>

        <p>We use cookies and similar tracking technologies to track activity related to the ApiMoon Services. Please refer to Article 6 to learn
            more.</p>

        <h2>3. PURPOSES OF PERSONAL DATA PROCESSING</h2>

        <p>3.1 We process Personal Data for the following purposes:</p>

        <h2>4. RETENTION AND TRANSFER OF PERSONAL DATA</h2>

        <p>4.1 We will retain and process Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy and only
            to the extent necessary to comply with our legal obligations, resolve disputes, exercise our rights and protect our interests. In
            particular, we will process Personal Data for the following periods of time:</p>

        <p>4.2 Please note that we may retain usage data for internal analysis purposes. We retain usage data generally for a shorter period of
            time, except when this data is used to strengthen the security or to improve the functionality of the ApiMoon Services, or if we have
            a legal duty to retain this data for longer time periods.
        </p>

        <p>4.3 Personal Data we process may be transferred to (and maintained on) a computer located outside of your state, province, country or
            other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction. We store all data using
            Amazon AWS for all our customers irrespective of their location. Your consent with this Privacy Policy followed by your submission of
            respective Personal Data represents your agreement to such transfer.</p>

        <p>4.4 We will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy
            Policy and that no Personal Data are transferred to any organization or a country unless there are adequate controls in place
            ensuring the security of Personal Data.</p>

        <h2>5. DISCLOSURE OF PERSONAL DATA</h2>

        <p>5.1 We may disclose Personal Data to a third party in particular in connection with:</p>

        <strong>a. Business Transactions</strong>
        <p>We may disclose Personal Data to any third party that acquires all or substantially all of our business, stocks or assets, or with
            whom we merge or undergo any other form of corporate restructuring. If we do, we will inform such third party of the requirement to
            process Personal Data in accordance with this Privacy Policy.</p>

        <strong>b. Disclosure for Law Enforcement</strong>

        <p>We may, under certain circumstances, be required to disclose Personal Data by law or in response to requests made by public
            authorities (e.g. a court or a government agency).</p>

        <strong>c. Legal Requirements</strong>

        <p>We may disclose Personal Data if we believe in good faith that such disclosure is necessary in order to: (i) comply with a legal
            obligation, (ii) protect and/or defend our rights or property, (iii) prevent or investigate possible wrongdoing in connection with
            the ApiMoon Services, (iv) protect the safety of users of the ApiMoon Services or the public, (v) protect against legal
            liability.</p>

        <p>5.2 By clicking the “I agree” checkbox during registration as a user of the ApiMoon Services or simply by using the ApiMoon Services,
            you consent to our sharing of Personal Data with third parties such as:</p>

        <p>5.3 Google API Disclosure for the ApiMoon Services

            The ApiMoon Services use and transfer of information received from Google APIs to any other app will adhere to Google API Services
            User Data Policy, including the Limited Use requirements.</p>

        <h2>6. TRACKING, COOKIES AND IP ADDRESSES</h2>

        <p>6.1 Cookies are computer files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your
            browser from a website and stored on your device. Tracking technologies also use beacons, tags and scripts to collect and track
            information and to improve and analyze the ApiMoon Services. Cookies allow us to recognize whether you re-entered our website from
            the same device, to record some of your stored parameters and to verify whether you belong to a particular category of users to which
            certain communication should be targeted. We may use for example the following categories of cookies:</p>

        <p>6.2 You can instruct your browser to refuse cookies except for technical cookies or similar or to indicate when a cookie is being
            sent.</p>

        <p>6.3 When you visit our website for the first time, we ask you whether you accept cookies.</p>

        <p>6.4 With your consent we also use Google Analytics and similar services that collect third-party cookies. Google Analytics is a web
            analytics service offered by Google that tracks and reports website traffic. Aside from Google Analytics, Google uses Google Tag
            Manager which is a tag management system created by Google to manage JavaScript and HTML tags used for tracking and analytics on
            websites. The information about your use of the ApiMoon Services (including your IP address) generated by the cookies will be
            transmitted to and stored by Google on servers in the USA and other countries. Google will use this information for the purpose of
            evaluating your use of the ApiMoon Services, compiling reports on the ApiMoon Services activity for the ApiMoon Services operators,
            and providing other services relating to the ApiMoon Services activity and internet usage. Google may also transfer this information
            to third parties where required to do so by law or where such third parties process the information on Google’s behalf. By using our
            ApiMoon Services, you consent to the processing of your data by Google in the manner and for the purposes set out above as further
            detailed in Google privacy policy available at: https://policies.google.com/privacy.</p>

        <p>6.5 The ApiMoon Services and the communications generated by the use the ApiMoon Services, such as promotional e-mails, may also
            contain electronic images known as “web beacons”. Web beacons generally work in conjunction with cookies, and we may use them in the
            same way we use cookies (see above).</p>

        <h2>7. DIRECT MARKETING</h2>

        <p>7.1 By clicking the “I agree” checkbox during registration as a user of the ApiMoon Services or simply by using the ApiMoon Services,
            or by clicking the “I agree” checkbox when subscribing to our newsletters or other marketing communications, surveys etc., you agree
            that we may use your electronic contact details, which may be derived from your current or past usage of the ApiMoon Services, or
            permit selected third parties to use this data, to contact you via electronic means (such as e-mail) with marketing information about
            the ApiMoon Services.</p>

        <p>7.2 You may opt out of marketing communications by disabling this function via the unsubscribe link provided in each e-mail or other
            communication you receive, or by sending an e-mail request to support@apimoon.com specifying that you wish to opt out from marketing
            communications.</p>

        <h2>8. SECURITY</h2>

        <p>8.1 We are committed to storing all Personal Data securely. Therefore, we have implemented adequate physical, technical and
            organizational measures and plans for protecting and securing Personal Data (which do not, however, deprive you of your
            responsibility for taking adequate steps to secure your data, particularly for the transmission of data). Our aim is to eliminate any
            unauthorized or unlawful processing of Personal Data as well as any accidental, unauthorized or unlawful accessing, use,
            transferring, processing, copying, transmitting, alteration, loss or damage of Personal Data.</p>

        <p>8.2 Where we have given you (or where you have chosen) a password which enables you to access certain parts of the ApiMoon Services,
            you are responsible for keeping this password strong and confidential. We ask you not to share the password with unauthorized
            persons.</p>

        <p>8.3 Unfortunately, the transmission of information via the internet is never completely secure. Although we will do our best to
            protect Personal Data, we cannot guarantee the security of Personal Data transmitted by you. Any such transmission is at your own
            risk. Once we have received Personal Data, we will use strict procedures and security measures to protect Personal Data and prevent
            unauthorized access.</p>

        <p>8.4 To maintain the highest standard of Personal Data protection, all information you provide to us is stored on secure servers behind
            firewalls. We restrict access to Personal Data to employees, contractors and agents who need to know such Personal Data in order to
            operate, develop or improve the ApiMoon Services.</p>
        <p>8.5 Certain parts of the ApiMoon Services that collect personal data also use Secure Sockets Layer (SSL) encryption or other types of
            encryption. We back up all Customer data in the data center located in US and Europe, which enables an expedited recovery in case of
            a disaster or other event of similar nature, and whenever possible, we will ensure the pseudonymization or anonymization of all
            personal or related data (except for names and e-mail addresses).</p>

        <h2>9. YOUR RIGHTS</h2>

        <p>9.1 Subject to the rules and conditions set forth in the GDPR, you are or may be eligible to the following rights in relation to your
            Personal Data:</p>

        <strong>a. Right of access</strong>
        <p>ou are eligible to request from us confirmation, as to whether or not Personal Data concerning you are being processed and, if this is
            the case, you may access further information about such processing. Your right of access can be exercised in accordance with the
            applicable laws. However, where requests from you are manifestly unfounded, excessive or repetitive, we may either:

            <ul>
                <li>1. charge a reasonable fee, considering the administrative costs of taking the actions requested; or</li>
                <li>2. refuse to act on the request.</li>
            </ul>

        </p>


        <strong>b. Right to erasure (right to be forgotten)</strong>

        <p>You are eligible to request from us the erasure of Personal Data concerning you without undue delay and we shall have the obligation
            to erase such data without undue delay if all respective conditions are met under the GDPR. Please note that erasure of your Personal
            Data may result in our inability to provide you with our services.</p>

        <strong>c. Right of rectification</strong>
        <p>You are eligible to request from us without undue delay the rectification of inaccurate or incomplete Personal Data concerning
            you.</p>

        <strong>d. Right to object</strong>
        <p>You are eligible to object, on grounds relating to your particular situation at any time, to the processing of Personal Data.</p>

        <strong>e. Right of restriction of processing</strong>
        <p>You are eligible to request from us the restriction of processing of Personal Data.</p>

        <strong>f. Right to data portability</strong>
        <p>You are eligible to receive Personal Data concerning you, which you have provided to us, in a structured, commonly used and
            machine-readable format, and you have the right to transmit those data to another controller without hindrance from us to which
            Personal Data have been provided.</p>

        <strong>g. Right to withdraw consent</strong>
        <p>You are eligible, where the processing is based on consent, to withdraw your consent at any time. Such withdrawal shall not affect the
            lawfulness of processing based on your consent before its withdrawal.</p>

        <p>9.2 If you feel that your Personal Data have been processed unlawfully, please contact us at support@apimoon.com and we will resolve
            the problem. You have the right to lodge a complaint with the competent supervisory authority. A list of competent supervisory
            authorities in the European Union is available at
            https://ec.europa.eu/digital-single-market/en/news/list-personal-data-protection-competent-authorities. In the Czech Republic, the
            competent supervisory authority is the Office for Personal Data Protection. You can learn more at https://www.uoou.cz/en/.</p>

        <p>9.3 Please keep in mind that we respond to all enquiries within 30 days. Any requested change, once we have verified your identity and
            the request’s legitimacy, may take up to five (5) business days to take effect.</p>

        <h2>10. SURVEYS AND TESTIMONIALS</h2>

        <p>10.1 From time to time, we may request information via surveys. Participation in these surveys is voluntary and you may choose whether
            or not to participate and disclose the requested information. Information requested may include contact information (such as name and
            e-mail address), and organization information (organization name, job position). Contact information will be used to share the
            results if the participant selects to receive them. Survey information will be used for purposes of research, monitoring or improving
            the user experience and satisfaction with the ApiMoon Services.</p>

        <p>10.2 From time to time, we may also post various texts such as testimonials, quotes, case studies, white papers etc. on our websites
            that may contain personal information. We shall obtain your consent to post your name along with such text. If you wish to update or
            delete any text containing your personal information, please contact us at support@apimoon.com.</p>

        <h2>11. FINAL PROVISIONS</h2>

        <p>11.1 The ApiMoon Services may, from time to time, contain links to and from websites of our partner networks, advertisers and
            affiliates. If you follow a link to any of these websites, please note that these websites have their own privacy policies and that
            we do not accept any responsibility or liability for these policies. Please check these policies before you submit any Personal Data
            to these websites.</p>

        <p>11.2 The ApiMoon Services are not addressed to anyone under the age of 18. We do not, to our best knowledge, collect Personal Data
            from anyone under the age of 18. If you are a parent or a guardian and you are aware that your child has provided us with Personal
            Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental
            consent, we will take steps to remove that information from our servers.</p>

        <p>11.3 We reserve the right to amend, modify, supplement or otherwise change this Privacy Policy at any time and for any reason. Any new
            version of this Privacy Policy supersedes its previous version as of the date of effectivity of the new version.</p>

        <p>11.4 If you have any questions about this Privacy Policy or our privacy practices, please contact us by email at
            support@apimoon.com.</p>

        <strong>This Privacy Policy enters into force and become effective as of 15. May 2023.</strong>

    </CenteredDesign>

}